import gql from 'graphql-tag';

export const GET_CUSTOMER_CONTACTS = gql`
  query GetCustomerContacts($customerAccountId: ID!) {
    customer {
      customerContacts(customerAccountId: $customerAccountId) {
        error
        success
        list {
          ownerPgId
          creditApplicationId
          firstName
          lastName
          title
          phone
          lastContactDate
        }
      }
    }
  }
`;
